import React, {useEffect, useState} from 'react';
import './banks.scss';
import SAGICOR_LOGO from 'assets/logo/sagicor_logo.svg';
import SCOTIA_LOGO from 'assets/logo/scotia_logo.svg';
import DEVELOPMENT_BANK_LOGO from 'assets/logo/development_bank_logo.svg';
import JAMAICA_NATIONAL_LOGO from 'assets/logo/jamaica_national_logo.svg';
import JMMB_LOGO from 'assets/logo/jmmb_logo.svg';
import NCB_LOGO from 'assets/logo/ncb_logo.svg';
import {ReactComponent as ELEMENT_O4} from 'assets/accounting-finance/elements/af_element_04.svg';
import {useMediaQuery} from "react-responsive";

const banks: { image: any, heading: string, description: string, link: string }[] = [
    {
        image: SAGICOR_LOGO,
        heading: "Micro & Small Businesses Funding",
        description: "Access financing by wholesaling funds made available through our wide network of credit unions.",
        link: "https://www.sagicor.com/en-jm/business-solutions/banking"
    },
    {
        image: SCOTIA_LOGO,
        heading: "Scotia Bank Term Loans for Business",
        description: "A term loan can help when you are planning to purchase major fixed assets.",
        link: "https://jm.scotiabank.com/small-business/borrowing/term-loans-for-business.html"
    },
    {
        image: DEVELOPMENT_BANK_LOGO,
        heading: "Loans through Approved Financial Institutions",
        description: "The Development Bank of Jamaica provides loans for Micro, Small & Medium-sized Enterprises.",
        link: "https://dbankjm.com/financing/loans-through-approved-financial-institutions-afis/"
    },
    {
        image: JAMAICA_NATIONAL_LOGO,
        heading: "Jamaica National Small Businesses Loans",
        description: "Whatever your goals, let’s help you get there with a loan from JN Bank Small Businesses Loans",
        link: "https://www.jnbank.com/small-business-loans/"
    },
    {
        image: JMMB_LOGO,
        heading: "Corporate Banking and Commercial Loans",
        description: "Loan services that can help you streamline your financial operations and manage daily business needs.",
        link: "https://jm.jmmb.com/business-loans"
    },
    {
        image: NCB_LOGO,
        heading: "SME Development Loan Fund",
        description: "Provide a special loan guarantee for SMEs in select Caribbean countries with collateral constraints, which will enable them to access funding.",
        link: "https://www.jncb.com/Business/Loans-Financing/SME-Development-Loan-USAID"
    }
]
const Banks = () => {
    const isTablet = useMediaQuery({query: '(max-width: 768px)'});
    const [sliceCount, setSliceCount] = useState(2)
    const [localBanks, setLocalBanks] = useState<{ image: any, heading: string, description: string, link: string }[]>([])

    useEffect(() => {
        if (isTablet) {
            setLocalBanks(banks.slice(0, sliceCount))
        }

        if (!isTablet) {
            setLocalBanks(banks)
        }

    }, [isTablet, sliceCount]);

    const hideShowBanks = () => {
        if (sliceCount > 2)
            setSliceCount(2)

        if (sliceCount <= 2) {
            setSliceCount(100)
        }
    }

    return (
        <div className={"banks"} id={'business-banks'}>
            <ELEMENT_O4 className={'banks_element_04'}/>
            <div className={"banks_wrapper max"}>
                <h1>Local Banks Loan Services</h1>
                <p>Access loans from various financial institutions in Jamaica by checking out their small business
                    loans pages to find out how they can assist you with obtaining a loan for your business. </p>

                <div className={"banks_wrapper_banks"}>
                    {
                        localBanks.map(({image, heading, description, link}, index) => (
                            <div className={"banks_wrapper_banks_bank"} key={heading + index}>
                                <div className={"banks_wrapper_banks_bank_top"}>
                                    <img src={image} alt=""/>
                                    <h1>{heading}</h1>
                                    <p>{description}</p>
                                </div>
                                <div className={"banks_wrapper_banks_bank_bottom"}>
                                    <a className={'banks_wrapper_banks_bank_bottom_cta'} href={link} target="_blank">Learn
                                        More</a>
                                </div>
                            </div>
                        ))}
                </div>
                {isTablet && <div id={'hide-show-banks'} onClick={hideShowBanks}>{sliceCount > 2 ? 'show Less' : 'Show More'}</div>}
            </div>
        </div>
    );
};

export default Banks;
